<template>
<div class="chapter">
<div class="inner_page">
<div class="copy">
<p class="toc">Published with assistance from the Louis Stern Memorial Fund.<br/><br/></p>
<p class="toc">Copyright © 2008 by Yale University. All rights reserved.<br/>
This book may not be reproduced, in whole or in part, including<br/>illustrations, in any form (beyond that copying permitted by<br/>Sections 107 and 108 of the U.S. Copyright Law and except by<br/>reviewers for the public press), without written permission from the publishers.<br/><br/></p>
<p class="toc">Set in Electra type by Tseng Information Systems, Inc.<br/>
Printed in the United States of America.<br/><br/></p>
<p class="toc">Library of Congress Cataloging-in-Publication Data<br/>
Hämäläinen, Pekka, 1967-<br/>
The Comanche empire / Pekka Hämäläinen.<br/>
p. cm. — (The Lamar series in western history)<br/>
Includes bibliographical references and index.<br/>
“Published in cooperation with the William P. Clements Center<br/>for Southwest Studies, Southern Methodist University.”<br/>
ISBN 978-0-300-12654-9 (cloth : alk. paper)<br/>
1. Comanche Indians — History. 2. Comanche Indians — Government relations.<br/>3. United States — History—19th century. 4. Mexico — History—To 1810.<br/>I. William P. Clements Center for Southwest Studies. II. Title.<br/>
E99.c85.H27 2008<br/>
978.004’974572—dc22<br/>
2007041809<br/><br/></p>
<p class="toc">A catalogue record for this book is available from the British Library.<br/><br/></p>
<p class="toc">The paper in this book meets the guidelines for permanence and durability<br/>of the Committee on Production Guidelines for Book Longevity of the<br/>Council on Library Resources.<br/><br/></p>
<p class="toc">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?3e45a2aa